var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('div',{staticClass:"topbar-inner"},[_c('router-link',{staticClass:"section-logo",attrs:{"to":{ name: 'Landing' }}},[_c('img',{attrs:{"src":require("@/assets/RediR.png")}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }